export const getrecipereq="getrecipereq"
export const getrecipesucc='getrecipesucc'
export const getrecipefail="getrecipefail"